import {
  combine,
  withMemo,
  withContext,
  withCallbacks,
} from 'react-hooks-combine'

import { withTableController } from 'shared/hooks'
import { StoreContext } from 'store/context'
import { ServicesContext } from 'services/context'

import { createColumns } from './columns.description'
import { createColumns as createFavoriteColumns } from './columnsFavorite.columns.description'
import BeneficiariesComponent from './component'

export default combine(
  withTableController({ id: 'teams-table' }),
  withTableController({ id: 'favorite-teams-table' }),
  withContext('teamService', ServicesContext, ({ teamService }) => teamService),
  withContext(
    'followerService',
    ServicesContext,
    ({ followerService }) => followerService
  ),
  withContext('appStore', StoreContext),
  withMemo('columns', () => createColumns(), []),
  withMemo('favoriteColumns', () => createFavoriteColumns(), []),
  withCallbacks(
    {
      loadAthletes:
        ({ teamService }) =>
        async (tableState) =>
          await teamService.query({
            page: tableState.page,
            size: tableState.pageSize,
          }),

      loadFavoriteAthlete:
        ({ followerService }) =>
        async (tableState) =>
          await followerService.getTeamFollowers({
            page: tableState.page,
            size: tableState.pageSize,
          }),

      onSearch:
        ({ table }) =>
        (query) => {
          table.search(query)
        },
    },
    []
  )
)(BeneficiariesComponent)
